import { ChangeEvent, FC } from "react";
import {
  ACTIVE_SORT_OPTIONS,
  ARCHIVED_VALID_SORT_OPTIONS,
  GroupByOption,
  SORT_OPTIONS,
  SortByOption,
  SortGroupState,
} from "@app/network-portfolio-management/interfaces";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

export interface SortGroupControlsProps {
  setSortGroupState: (state: SortGroupState) => void;
  sortGroupState: SortGroupState;
  archivedView?: boolean;
}

// Each view exposes sorts that may match other views or have its own. ACTIVE_SORT_OPTIONS and
// ARCHIVED_VALID_SORT_OPTIONS are the single source of truth, shared with sortGroupStorage.ts's
// persistence validity check.
const ACTIVE_VIEW_OPTIONS = SORT_OPTIONS.filter((opt) => ACTIVE_SORT_OPTIONS.includes(opt.value));
const ARCHIVED_SORT_OPTIONS = SORT_OPTIONS.filter((opt) => ARCHIVED_VALID_SORT_OPTIONS.includes(opt.value));

const GROUP_OPTIONS: { label: string; value: GroupByOption }[] = [
  { label: "None", value: GroupByOption.None },
  { label: "Line of Business", value: GroupByOption.LineOfBusiness },
];

export const SortGroupControls: FC<SortGroupControlsProps> = ({ setSortGroupState, sortGroupState, archivedView }) => {

  const handleSortChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    setSortGroupState({ ...sortGroupState, sortBy: e.target.value as SortByOption });
  };

  const handleGroupChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    setSortGroupState({ ...sortGroupState, groupBy: e.target.value as GroupByOption });
  };

  const sortOptions = archivedView ? ARCHIVED_SORT_OPTIONS : ACTIVE_VIEW_OPTIONS;

  return (
    <div className="network-portfolio-management-sort-group-controls">
      <QESSelect
        allowEmpty={false}
        containerClassName="network-portfolio-management-sort-group-controls__container"
        label="Sort by"
        testId="npm-sort-by"
        value={sortGroupState.sortBy}
        onChange={handleSortChange}
      >
        {sortOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </QESSelect>
      <QESSelect
        allowEmpty={false}
        containerClassName="network-portfolio-management-sort-group-controls__container"
        disabled={archivedView}
        label="Group by"
        testId="npm-group-by"
        value={sortGroupState.groupBy}
        onChange={handleGroupChange}
      >
        {GROUP_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </QESSelect>
    </div>
  );
};
